import {Controller} from "stimulus"
import $ from 'jquery';

export default class extends Controller {

    initialize() {
            this.clone_area = $(`#${this.element.dataset.clone}`);
            this.number_of_field = this.clone_area.find('.clone');

            if (this.clone_area ) {
                if (this.number_of_field.length === 0) {
                    this.clone_area.append(this.tpl_range(this.number_of_field.length));
                }
            }
    }

    connect() {
       if(this.element.type === 'checkbox'){
           this.element.addEventListener('change', (e) => {
               let dataset = e.target.dataset;
               let click_event = e.target;
               if(dataset.hasOwnProperty('check')){
                   let dataset_child = $(`#${dataset.check}`)
                   dataset_child.prop('checked', !click_event.checked)
                   setTimeout(()=>{
                       this.check_unchek(dataset_child[0].dataset,dataset_child[0], 'secondary')
                   },200)


               }
               if(dataset.hasOwnProperty('target')){
                   setTimeout(()=>{
                       this.check_unchek(dataset,click_event, 'main')
                   },200)

               }
           })
       }
    }

    check_unchek(dataset, click_event, ho){
        let target_html = $(`#${dataset.target}`)
        let inputs = target_html.find('input')
        if(inputs.length > 0){
            inputs.map((index, elem)=> {
                if(click_event.checked){
                    $(elem).removeAttr('readonly');
                }else{
                    $(elem).attr('readonly','readonly')
                }
            })
        }
    }

    count_elements(){
        this.number_of_field = this.clone_area.find('.clone');
    }
    add(e){
        this.count_elements();
        let checked = false;
        if(e.target.dataset.hasOwnProperty('depend')){
            checked = $(`#${e.target.dataset.depend}`)[0].checked;
        }

        if(checked){
            this.clone_area.append(this.tpl_range(this.number_of_field.length, checked));
        }
    }

    tpl_range(index, checked= false){
        let readonly =``
        if(!checked){
             readonly = `readonly="readonly"`
        }

        return `<div class="mb-3 row clone" id="clone_${index}">
            <div class="col-md-4">
              <label class="mb-1" for="range_price_from">
               Desde
              </label>
              <input class="form-control input-sm" min="1" step="1" type="number" name="range_price_[${index}][from]" id="range_price_from_${index}" ${readonly}>
            </div>
            <div class="col-md-4">
              <label class="mb-1" for="season_day_range_to">
                Hasta
</label>              <input class="form-control" min="1" step="1" type="number" name="range_price_[${index}][to]" id="range_price_to_${index}" ${readonly}>
            </div>
            <div class="col-md-3">
              <label class="mb-1" for="season_day_range_price">
                Precio
</label>              <input class="form-control" type="text" name="range_price_[${index}][price]" id="range_price_price_${index}" ${readonly}>
            </div>
            <div class="col-md-1">
            <button type="button" class="btn btn-danger" onclick="$('#clone_${index}').remove();" style="position: absolute;bottom: 5px;"><span class="icon-trash"></span> </button>
             </div>
          </div>`
    }

}